import { useTranslation } from "react-i18next";

export default function ContactCTA() {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-20 md:py-28 bg-accent-500 relative overflow-hidden">
      <div className="relative max-w-4xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block text-xs uppercase tracking-[0.2em] text-accent-100 font-medium mb-3">
          {t("ct_badge")}
        </span>
        <h2 className="font-heading text-3xl md:text-5xl font-semibold text-background-50 mb-4">
          {t("ct_social_heading")}
        </h2>
        <p className="text-accent-100 text-base leading-relaxed mb-12 max-w-xl mx-auto">
          {t("ct_social_subtitle")}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <a
            href="https://www.instagram.com/mateo_teneryfa?igsh=MWIyd3EyOWhlMmp6Yw=="
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center gap-4 bg-background-50/10 hover:bg-background-50/20 backdrop-blur rounded-lg p-8 transition-all cursor-pointer border border-background-50/10 hover:border-background-50/25"
          >
            <div className="w-16 h-16 rounded-full bg-background-50/15 flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-instagram-line text-3xl text-background-50"></i>
            </div>
            <div>
              <div className="font-heading text-xl font-semibold text-background-50">Instagram</div>
              <div className="text-accent-100 text-sm mt-1">@mateo_teneryfa</div>
            </div>
          </a>

          <a
            href="https://www.facebook.com/share/18s1Yq8cTT/"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center gap-4 bg-background-50/10 hover:bg-background-50/20 backdrop-blur rounded-lg p-8 transition-all cursor-pointer border border-background-50/10 hover:border-background-50/25"
          >
            <div className="w-16 h-16 rounded-full bg-background-50/15 flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-facebook-fill text-3xl text-background-50"></i>
            </div>
            <div>
              <div className="font-heading text-xl font-semibold text-background-50">Facebook</div>
              <div className="text-accent-100 text-sm mt-1">Mateo Teneryfa</div>
            </div>
          </a>

          <a
            href="mailto:kontakt@mateoteneryfa.pl"
            className="group flex flex-col items-center gap-4 bg-background-50/10 hover:bg-background-50/20 backdrop-blur rounded-lg p-8 transition-all cursor-pointer border border-background-50/10 hover:border-background-50/25 sm:col-span-2 lg:col-span-1"
          >
            <div className="w-16 h-16 rounded-full bg-background-50/15 flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-mail-line text-3xl text-background-50"></i>
            </div>
            <div>
              <div className="font-heading text-xl font-semibold text-background-50">Email</div>
              <div className="text-accent-100 text-sm mt-1">kontakt@mateoteneryfa.pl</div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}